
// Environment variables for the application
// These are exposed to the client, so don't include sensitive information

export const SUPABASE_URL = "https://videvqtlwuoeyemuhyqy.supabase.co";
export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpZGV2cXRsd3VvZXllbXVoeXF5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDE5MTA0NDIsImV4cCI6MjA1NzQ4NjQ0Mn0.Fd9ZH_XiP5m3sN6kx5uHfXBvr1WC-V55k8r_8dGVxaw";

// More detailed validation for environment variables
if (!SUPABASE_URL) {
  console.error("CRITICAL ERROR: SUPABASE_URL is missing");
} else if (!SUPABASE_URL.includes("supabase.co")) {
  console.error("CRITICAL ERROR: SUPABASE_URL appears to be invalid:", SUPABASE_URL);
}

if (!SUPABASE_ANON_KEY) {
  console.error("CRITICAL ERROR: SUPABASE_ANON_KEY is missing");
} else if (SUPABASE_ANON_KEY.length < 30) {
  console.error("CRITICAL ERROR: SUPABASE_ANON_KEY appears too short to be valid");
}

// Detailed logging of Supabase configuration
console.log("Supabase configuration loaded:", { 
  url: SUPABASE_URL ? `${SUPABASE_URL.substring(0, 15)}...` : 'MISSING', 
  keyValid: SUPABASE_ANON_KEY && SUPABASE_ANON_KEY.length > 20,
  urlValid: SUPABASE_URL && SUPABASE_URL.includes("supabase.co"),
  keyPrefix: SUPABASE_ANON_KEY ? SUPABASE_ANON_KEY.substring(0, 10) + "..." : "MISSING"
});

// Enhanced function to test if the keys are valid
export const validateSupabaseKeys = () => {
  const isUrlValid = SUPABASE_URL && SUPABASE_URL.includes("supabase.co");
  const isKeyValid = SUPABASE_ANON_KEY && SUPABASE_ANON_KEY.length > 20;
  
  if (!isUrlValid) {
    console.error("Invalid Supabase URL format:", SUPABASE_URL);
  }
  
  if (!isKeyValid) {
    console.error("Invalid Supabase key format:", 
      SUPABASE_ANON_KEY ? `${SUPABASE_ANON_KEY.substring(0, 5)}...` : "MISSING");
  }
  
  // More detailed validation results
  console.log("Supabase configuration validation:", {
    isUrlValid,
    isKeyValid,
    canConnect: isUrlValid && isKeyValid
  });
  
  return isUrlValid && isKeyValid;
};

// Run validation immediately
validateSupabaseKeys();
